import {
  alpha,
  AppBar,
  createTheme,
  IconButton,
  StyledEngineProvider,
  Theme,
  ThemeProvider,
  Toolbar as MatToolbar,
  Tooltip,
  Typography
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import {useTranslation} from 'react-i18next';
import {toggleDrawer} from '../../../../features/layout/layoutSlice';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useAppDispatch} from '../../../store';
import {ReactComponent as Logo} from '../../../../admin-blue-circle.svg';
import {homePage} from '../../../utils/routes';
import {NavLink} from 'react-router-dom';
import version from '../../../../version';


declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}


const theme = createTheme({
  palette: {
    primary: {
      main: '#173D65',
    },
  },
});

const useStyles = makeStyles((theme) => ({
  matToolbar:{
    paddingLeft: theme.spacing(2),
    paddingRight:theme.spacing(2)
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    flexGrow: 1,
    transition: theme.transitions.create('opacity'),
    '&.closed': {
      opacity: 0,
    },
  },
  navLink:{
    display: 'inline-flex',
    alignItems: 'center'
  },
  iconButton: {
    width: 40,
    height: 40,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: alpha(theme.palette.background.paper, 0.25),
    },
  },
  logo: {
    height: '2.267em',
    width: 'auto',
    marginRight: theme.spacing(1.25),
  },
}));

export function DrawerToolbar(props: { open: boolean }): JSX.Element {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const trimmedVersion = version.split('-')[0];
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <AppBar position="sticky">
          <MatToolbar className={classes.matToolbar} variant="dense">
            <Typography
              className={`${classes.title}${props.open ? '' : ' closed'}`}
              fontWeight={600}
              variant='h6'
              noWrap
            >
              <NavLink to={homePage.path} key={homePage.id} className={classes.navLink}>
                <Tooltip title={
                  <div style={{ whiteSpace: 'pre-line' }}>{`Versjon: ${trimmedVersion}\n`}</div>
                }>
                  <Logo className={classes.logo} />
                </Tooltip>
                {t('Admin+')}
              </NavLink>
            </Typography>

            <IconButton
              onClick={() => dispatch(toggleDrawer())}
              color="inherit"
              size="small"
              aria-label={t('Vis eller skjul navigasjonspanel')}
              className={classes.iconButton}
            >
              {props.open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </MatToolbar>
        </AppBar>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
